import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
import verifiedWhite from "../assets/verified-white.svg";
import { http, baseURL } from "../misc/http";
import history from "../misc/history";
import useWindowDimensions from "../misc/windowDimensions";
import defaultUser from "../assets/default-user.png";
import penyelenggara from "../assets/penyelenggara-sertifikat-elektronik.png";

export default function Navbar() {
  const [dropdownInformasi, setDropdownInformasi] = useState("");
  const [dropdownKegiatan, setDropdownKegiatan] = useState("");
  const [dropdownUser, setDropdownUser] = useState("");
  const [user, setUser] = useState({});
  const [profiles, setProfiles] = useState({});
  const [isLogin, setIsLogin] = useState(false);
  const { width } = useWindowDimensions();

  const handleDropDownInformasi = () => {
    setDropdownInformasi("show");
    setDropdownKegiatan("");
    setDropdownUser("");
  };
  const handleDropDownKegiatan = () => {
    setDropdownInformasi("");
    setDropdownKegiatan("show");
    setDropdownUser("");
  };
  const handleDropDownUser = () => {
    setDropdownInformasi("");
    setDropdownKegiatan("");
    setDropdownUser("show");
  };

  const getLocalData = async () => {
    let userLocal = JSON.parse(localStorage.getItem("kominfo-psre"));
    if (userLocal !== null) {
      setUser(userLocal ? userLocal : {});
      setIsLogin(userLocal ? true : false);
      let params = {
        method: "GET",
        path: "profiles/" + userLocal.email,
        token: userLocal.token,
        showMessage: false,
      };
      let { data } = await http(params);
      if (data.status === true && data.code === 200) {
        setProfiles(data.data);
        setUser(userLocal);
      } else {
        setProfiles({});
        setUser(userLocal);
      }
    }
  };

  const handleClickOutside = (event) => {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      setDropdownInformasi("");
      setDropdownKegiatan("");
      setDropdownUser("");
    }
  };

  useEffect(() => {
    getLocalData();
    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("kominfo-psre");
    setUser({});
    setIsLogin(false);
    history.push("/");
  };

  const renderLogin = () => {
    return isLogin ? (
      <li
        className={`nav-item dropdown ${dropdownUser}`}
        style={{ listStyle: "none" }}
        onClick={() => handleDropDownUser()}
      >
        <div className="dropdown">
          <a
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded={dropdownUser === "" ? "false" : "true"}
            style={{ color: "black" }}
          >
            <span className="mr-3 ml-3 p-nunito" style={{ fontSize: "14px" }}>
              Profil
            </span>
            <img
              className="rounded-circle"
              src={profiles.picture ? baseURL + profiles.picture : defaultUser}
              alt="mar"
              style={{ width: "35px", height: "35px", objectFit: "cover" }}
            />
            <span className="mx-3 mt-3">
              <i className="fas fa-caret-down"></i>
            </span>
          </a>
          <div
            className={`dropdown-menu dropdown-menu-left ${dropdownUser}`}
            aria-labelledby="dropdownMenuLink"
          >
            <a
              className="dropdown-item p-nunito"
              href="/profiles"
              style={{ color: "black" }}
            >
              Akun Saya
            </a>
            {/* <a className="dropdown-item" href="./kegiatan-acara-saya.html" style={{color: 'black'}}>Kegiatan Acara Saya</a> */}
            <a
              className="dropdown-item logout p-nunito"
              href="#"
              style={{ color: "black" }}
              onClick={handleLogout}
            >
              Logout
            </a>
          </div>
        </div>
      </li>
    ) : (
      <li className="nav-item" style={{ listStyle: "none" }}>
        <Link className="nav-link ind p-nunito" to="/login">
          Masuk
        </Link>
      </li>
    );
  };

  return (
    <div className="bg-white navbar-light nav-atas">
      <nav className="navbar navbar-expand-xl container ">
        <a className="navbar-brand" href="/" style={{ margin: 0 }}>
          <img
            src={penyelenggara}
            alt="penyelenggara-sertifikat-elektronik"
            style={{ height: "53px", width: "auto" }}
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo02"
          aria-controls="navbarTogglerDemo02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse"
          id="navbarTogglerDemo02"
          style={{ background: "white" }}
        >
          <div
            className={
              width >= 1200 ? "form-inline my-2 my-lg-0" : "my-2 my-lg-0"
            }
            style={
              width >= 1200
                ? {
                    position: "absolute",
                    right: 0,
                  }
                : {}
            }
          >
            <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
              <li
                className={`nav-item dropdown active ${dropdownInformasi}`}
                onClick={handleDropDownInformasi}
              >
                <Link
                  className="nav-link dropdown-toggle p-nunito "
                  id="navbarDropdown"
                  to="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={dropdownInformasi === "" ? "false" : "true"}
                >
                  Informasi <span style={{ marginRight: 5 }} />
                </Link>
                <div
                  className={`dropdown-menu ${dropdownInformasi}`}
                  aria-labelledby="navbarDropdown"
                >
                  <Link className="dropdown-item p-nunito" to="/apaitu">
                    Profil
                  </Link>
                  <Link className="dropdown-item p-nunito" to="/listpsrenew">
                    Daftar PSrE
                  </Link>
                  <Link
                    className="dropdown-item p-nunito"
                    to="/lembaga-sertifikat"
                  >
                    Lembaga Sertifikasi
                  </Link>
                  <Link className="dropdown-item p-nunito" to="/requirement">
                    Persyaratan PSrE
                  </Link>
                  <Link className="dropdown-item p-nunito" to="/regulation">
                    Regulasi, Panduan & Infografik
                  </Link>
                </div>
              </li>
              <li
                className={`nav-item dropdown active ${dropdownInformasi}`}
                onClick={handleDropDownKegiatan}
              >
                <Link
                  className="nav-link dropdown-toggle p-nunito "
                  id="navbarDropdown"
                  to="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={dropdownKegiatan === "" ? "false" : "true"}
                >
                  Berita dan Kegiatan <span style={{ marginRight: 5 }} />
                </Link>
                <div
                  className={`dropdown-menu ${dropdownKegiatan}`}
                  aria-labelledby="navbarDropdown"
                >
                  {/*<Link
                    className="nav-link p-nunito"
                    to="/event/all"
                    style={{ marginTop: 6 }}
                  >
                    Acara & Webinar{" "}
                    <span
                      style={{
                        backgroundColor: "#0093DD",
                        padding: "1px 7px",
                        fontSize: 10,
                        borderRadius: 7.5,
                        color: "white",
                      }}
                    >
                      Baru
                    </span>
                  </Link>*/}
                  <Link className="dropdown-item p-nunito" to="/event/blog">
                    Berita
                  </Link>
                  <Link className="dropdown-item p-nunito" to="/event/gallery">
                    Kumpulan Video & Galeri
                  </Link>
                </div>
              </li>
              {/* <li className="nav-item">
              <Link
                className="nav-link ind p-nunito"
                to="/event/all"
                style={{ color: "black" }}
              >
                Acara & Webinar{" "}
                <span
                  style={{
                    backgroundColor: "#0093DD",
                    padding: "1px 7px",
                    fontSize: 10,
                    borderRadius: 7.5,
                    color: "white",
                  }}
                >
                  Baru
                </span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link ind p-nunito"
                to="/event/blog"
                style={{ color: "black" }}
              >
                Berita
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link ind p-nunito"
                to="/event/gallery"
                style={{ color: "black" }}
              >
                Kumpulan Video & Galeri
              </Link>
            </li>  */}
            </ul>
            {/* </div> */}

            <div style={width < 1200 ? { height: 20 } : {}} />
            {/*renderLogin()}*/}
            <div style={width < 1200 ? { height: 10 } : {}} />
            <Link
              style={{
                backgroundColor: "#1672BD",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "6px 18px",
                borderRadius: 20,
                cursor: "pointer",
                width: 150,
              }}
              to="/verifyPDF"
            >
              <img
                className="mb-0"
                src={verifiedWhite}
                alt="verified"
                style={{
                  height: "15px",
                  objectFit: "contain",
                  marginRight: 2,
                }}
              />
              <p
                style={{ marginBottom: 0, color: "white" }}
                className="p-nunito"
              >
                Verifikasi PDF
              </p>
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}
